<template>
    <div class="content daily">
        <Loading v-if="loading"/>
        <div class="content-wrap res" v-else>
            <div class="total-score">
                <div class="score">
                    <img src="https://guokrapp-static.guokr.com/FpJF1lhrVj1OZL_U4c8VP7eL_vPJ"/>
                    <span :style="`color: ${scoreColor}`">{{result.total_score}}分</span>
                </div>
                <div class="num">
                    <p>答对{{result.correct_quiz_count}}题，共{{result.total_quiz_count}}题</p>
                    <p>扫码关注参与大赛，更多奖品等你来拿！</p>
                </div>
            </div>
            <div class="btns-wrap">
                <div class="custom-btn" @click="$router.go(-1)">返回</div>
                <div class="custom-btn" @click="handleCheck">查看解析</div>
            </div>
            <div class="qr-wrap">
                <img :src="qrcode"/>
                <p>
                    <!-- <img src="http://guokrapp-static.guokr.com/FnsMthIgcOkNeavK1kylE3l1VSdk"/> -->
                    2021农业生物技术科普大赛官方平台
                    <!-- <img src="http://guokrapp-static.guokr.com/FnsMthIgcOkNeavK1kylE3l1VSdk"/> -->
                </p>
                <p>
                </p>
            </div>
            <div class="share-mask" v-if="shareMaskVisible" @click="shareMaskVisible = false">
                <img src="http://guokrapp-static.guokr.com/FtigJuVRCz9YwPhszxrMXLsu_l9V"/>
            </div>
            <img src="https://guokrapp-static.guokr.com/FuiV4SQGxoFcj1EkFiKX_1-A0sWr" alt="" class="p2"/>
        </div>
    </div>
</template>

<script>
import { Loading } from 'vant';
import { cacQuizResultResultIdGet } from '@/apis/cac'

export default {
    name: 'Res',
    components: {
        Loading
    },
    data () {
        return {
            loading: true,
            shareMaskVisible: false,
            results: [],
            qrcode: ''
        }
    },
    computed: {
        result () {
            let result = {
                total_score: 0,
                correct_quiz_count: 0,
                total_quiz_count: this.results.length,
            }
            this.results.forEach((item) => {
                if (item.is_right) {
                    result.correct_quiz_count++
                    result.total_score += item.gotten_score
                }
            })
            return result
        },
        scoreColor () {
            const score = this.result.total_score
            if (score <= 100 && score >= 80) {
                return '#F85F48'
            } else if (score < 80 && score >= 50) {
                return '#0084C4'
            } else {
                return '#028769'
            }
        }
    },
    mounted () {
        this.getInfo()
        this.getQrcode()
    },
    methods: {
        async getInfo() {
            try {
                const {
                    body
                } = await cacQuizResultResultIdGet({
                    params: {
                        resultId: this.$route.params.result_id
                    }
                })

                this.results = body
                this.loading = false
            } catch (error) {
                this.$router.replace('/aola')
            }
        },
        async getQrcode () {
            this.qrcode = (await this.GLOBAL.getConfig('aolaQrcodeImg'))?.aolaQrcodeImg
        },
        handleCheck() {
            this.$router.push(`/aola/analysis/${this.$route.params.result_id}`)
        }
    }
};
</script>
<style lang="less" scoped>
.res {
    &.content-wrap {
        background-image: url(https://guokrapp-static.guokr.com/FgMdZ1-r6YLThoYYCdtFfwxybB9V);
        background-position: bottom center;
    }
    .total-score {
        border-top: 20px solid #fff;
        border-bottom: 20px solid #fff;
        background-image: url(https://guokrapp-static.guokr.com/FrHQhYkR9y6TXN_lsXLZO8fCbCzA);
        position: relative;
        width: 85vw;
        margin: 6vw auto 0;
        background-size: 100% 100%;
        flex: 1;
        min-height: 145px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        &::before {
            content: ' ';
            display: block;
            width: 36px;
            height: 18px;
            background-image: url(https://guokrapp-static.guokr.com/FnqEOQn6Cm1Zez1DBEgk78mysX9-);
            background-size: 100% 100%;
            position: absolute;
            left: 5px;
            top: -19px;
        }
        // &::after {
        //     content: ' ';
        //     width: 50px;
        //     height: 40px;
        //     background-image: url(http://guokrapp-static.guokr.com/Fo1c6vWJksRfLhdOU01byTrVnz_b);
        //     background-size: 100% 100%;
        //     position: absolute;
        //     right: 5px;
        //     bottom: 5px;
        // }
        .score {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 3vw;
            img {
                height: 8vw;
            }
            span {
                color: #0084C4;
                font-size: 9vw;
                // font-size: 40px;
                line-height: 56px;
                margin-left: 20px;
                font-weight: bold;
            }
        }
        .num {
            font-size: 4.4vw;
            // font-size: 17px;
            color: #000;
            line-height: 1.5;
            text-align: center;
        }
    }
    // p {
    //     margin-top: 4vh;
    //     color: #fff;
    //     font-size: 16px;
    //     text-align: center;
    // }
    .btns-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 3vh;
        flex-wrap: wrap;
        .btn {
            &:first-child{
                margin-right:3rem;
            }
        }
        .custom-btn {
            width: 34vw;
            height: 15vw;
            background-image: url(http://guokrapp-static.guokr.com/FjekSFAdnlWpwhJFiR-uG5hO5EU-);
            background-size: 100% 100%;
            line-height: 15vw;
            text-align: center;
            color: #007342;
            font-size: 5vw;
            // font-size: 20px;
            &:first-child{
                margin-right:3rem;
            }
        }
    }
    .qr-wrap{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 5vh;
        margin-top: 13vh;
        img{
            width: 20vh;
            height: 20vh;
            margin-top: 20px;
            margin-bottom: 3vh;
        }
        p{
            margin:0;
            text-align: center;
            color: #fff;
            // font-size: 1.2rem;
            font-size: 3.4vw;
            line-height: 1.5;
            display: flex;
            align-items: center;
            img {
                width: 8px;
                height: 10px;
                margin: 0 2px;
            }
        }
    }
    .share-mask {
        position: fixed;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
        z-index: 888;
        img {
            width: 50%;
        }
    }
    
    .p2 {
        position: absolute;
        bottom: 0;
        left: 4vw;
        width: 15vw;
    }
}
</style>
